// old、smb忘记密码的验证码组件
import React from 'react';
import {Modal,Form,Row,Col,Input,Button} from 'antd';
import style from './index.less';
const FormItem = Form.Item;
const getCodeUrl = (value)=>{
    const timest = new Date().getTime();
    return `/globalapi/user/login/step2/${value}/captcha?time=${timest}`;
};
class LoginCaptchaModal extends React.Component {

    codeRef = null;
    constructor(props){
        super(props);
        this.value = '';
        this.state = {
            visible:false,
            canSubCode:false,
            loading:false,
            codeUrl:''
        };
    }

    tagget = (isShow,value)=>{
        let codeUrl = '';
        if(isShow){
            this.value = value;
            codeUrl = getCodeUrl(this.value);
        }else{
            this.value = '';
        }
        this.setState({visible:isShow,codeUrl,loading:false});
    }

    onCodeChange = (e)=>{
        if(e.target.value.length === 4){
            this.setState({canSubCode:true});
        }else{
            this.setState({canSubCode:false});
        }
    }


    onCloseCodeModal = ()=>{
        this.setState({canSubCode:false,codeUrl:''});
        this.tagget(false);
    }

    refreshCode = ()=>{
        const {value} = this;
        this.setState({codeUrl:getCodeUrl(value)});
    }

    onOk = ()=>{
        if(!this.codeRef) return;
        this.setState({canSubCode:false});
        if(this.props.onOk){
            this.setState({loading:true});
            this.props.onOk(this.value,this.codeRef.input.value);
        }
    }


    render() {
        const {codeUrl,visible} = this.state;
        return (
            <Modal
                title=""
                visible={visible}
                onCancel={this.onCloseCodeModal}
                destroyOnClose={true}
                maskClosable={false}
                footer={null}
                width={517}
            >
                <div className={style.codeBox}>
                    <FormItem>
                        <Row gutter={15}>
                            <Col span={15}>
                                <Input ref={(ref)=>{this.codeRef = ref;}} onChange={this.onCodeChange} size="large"  type="text"/>
                            </Col>
                            <Col span={5}>
                                <img className={style.codeImg} src={codeUrl} alt=""/>
                            </Col>
                            <Col span={4}>
                                <a onClick={this.refreshCode}>(Refresh)</a>
                            </Col>

                        </Row>
                    </FormItem>
                    <div style={{textAlign:'center'}}>
                        <Button disabled={!this.state.canSubCode} onClick={this.onOk} className={style.button} type="primary" loading={this.state.loading}>Send</Button>
                    </div>
                </div>
            </Modal>
        );
    }

}

export default LoginCaptchaModal;



// WEBPACK FOOTER //
// ./src/pages/Login/LoginCaptchaModal/index.js